import { toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "columns"
};
var _hoisted_2 = {
  class: "column col-6 text-left"
};
var _hoisted_3 = {
  class: "column col-6 text-right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Modal = _resolveComponent("Modal");

  return _openBlock(), _createBlock(_component_Modal, {
    showTitle: true,
    ref: "dlg",
    showBody: false,
    class: "modal-sm"
  }, {
    title: _withCtx(function () {
      return [_createVNode("b", null, _toDisplayString($props.title), 1)];
    }),
    footer: _withCtx(function () {
      return [_createVNode("div", _hoisted_1, [_createVNode("div", _hoisted_2, [_createVNode("button", {
        class: "button",
        onClick: _cache[1] || (_cache[1] = _withModifiers(function () {
          return $options.confirm && $options.confirm.apply($options, arguments);
        }, ["prevent"]))
      }, "Potrdi")]), _createVNode("div", _hoisted_3, [_createVNode("button", {
        class: "button trans",
        onClick: _cache[2] || (_cache[2] = _withModifiers(function () {
          return $options.cancel && $options.cancel.apply($options, arguments);
        }, ["prevent"]))
      }, "Prekliči")])])];
    }),
    _: 1
  }, 512);
}